export const ABOUT = '/about'
